import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, CardTitlePrimary } from '@design-system-coopeuch/web';
import { stepperAction } from '../../../../application/actions/stepper';
import { agregarformatoPesos, obtieneNombreApellidos } from '../../../../utils';
import iconcedula from '../../../assets/img/icon/icon-Beneficio01.svg';
import iconprevisional from '../../../assets/img/icon/icon-Beneficio03.svg';
import iconliquidacion from '../../../assets/img/icon/icon-Beneficio02.svg';
import tarjetaDorada from '../../../assets/img/icon/Mobile-Dorada.svg';
import Botonera from '../Footer';
import { properties } from '../../../../utils/properties';
import { FuturaTarjetaWrapper } from './styles';
import Comprobante from '../Comprobante';
import DocumentoSucursalTemplate from '../DocumentosSucursal';

const GoldCardFinalizada = () => {
  const dispatch = useDispatch();
  const { futuratarjeta } = properties;
  const { boteneraTextos } = futuratarjeta;
  const [state] = useState({
    "menuPosition": 5,
    "botonera": [{ nameUno: boteneraTextos.botonDos, nameDos: boteneraTextos.botonUno }],
  });
  const [fechaCreacionNueva, setFechaCreacionNueva] = useState('');
  const [emailNuevo, setEmailNuevo] = useState('');
  const [nombreSocio, setNombreSocio] = useState('');
  const [cupoPesosNuevo, setCupoPesosNuevo] = useState('');
  const [cupoDolaresNuevo, setCupoDolaresNuevo] = useState('');

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);

  useEffect(() => {
    dispatch(stepperAction.fetchStepper(5));
  }, []);

  useEffect(() => {
    if (Object.keys(storeDataVerificacion).length && 'data' in storeDataVerificacion) {
      const { data } = storeDataVerificacion;
      const { nombres, apPaterno, apMaterno, email, fechaCreacion, cupoPesos, cupoDolares } = data;

      setEmailNuevo(email);
      setCupoPesosNuevo(cupoPesos);
      setCupoDolaresNuevo(cupoDolares);
      setFechaCreacionNueva(fechaCreacion);

      setNombreSocio(obtieneNombreApellidos(nombres, apPaterno, apMaterno));
    } else {
      window.location.replace('/');
    }
  }, [storeDataVerificacion]);
  
  const volveraCoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
  }

  const volveraCoopeuchNoSocios = () => {
    window.location.href = properties.urlNoSocios;
  }

  const { menuPosition, botonera } = state;

  return (
    <>
      {Object.keys(storeDataVerificacion).length > 0 &&
        <FuturaTarjetaWrapper>
          <div className="Titulo">
            <h1>Tu Tarjeta de Crédito te está esperando en Coopeuch</h1>
          </div>
          <div className="futura-tarjeta-header-gold">
            <div className="t-internacional t-internacional-texto">
              <p className="titulo">{properties.futuratarjeta.goldcardTitulo}</p>
              <p className="subtitulo">Permite acceder a la red de aceptación global de Mastercard, con exclusivos beneficios en Chile y el extranjero</p>
            </div>
            <div className="t-internacional">
              <img className="tarjetainternacional" src={tarjetaDorada} alt="internacional" />
              <div className="texto">
                <p className="p-internacional">
                  {`$ ${agregarformatoPesos(cupoPesosNuevo)} + US ${agregarformatoPesos(cupoDolaresNuevo)}`}
                </p>
                <p className="p-internacional-dos">
                  {nombreSocio}
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <Card className="Card-Class">
              <CardTitlePrimary title={properties.futuratarjeta.goldcardBenificios} />
              <CardContent>
                <div className="contenedor-gold-card">
                  <div className="info">
                    <img className="iconcedula" src={iconcedula} alt="cedula" />
                    <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.titulo}</p>
                    <p className="p-coment">
                      {properties.futuratarjeta.BeneficiosGold.bajada}
                    </p>
                  </div>
                  <div className="info">
                    <img className="iconliquidacion" src={iconliquidacion} alt="liquidacion" />
                    <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.tituloDos}</p>
                    <p className="p-coment">
                      {properties.futuratarjeta.BeneficiosGold.bajadaDos}
                    </p>
                  </div>
                  <div className="info">
                    <img className="iconprevision" src={iconprevisional} alt="prevision" />
                    <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.tituloTres}</p>
                    <p className="p-coment">{properties.futuratarjeta.BeneficiosGold.bajadaTres}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
            <div className="contenerdor-componente">
              <div className="contedor-comprobante">
                <Comprobante
                  data={storeDataVerificacion.data}
                  fechaCreacion={fechaCreacionNueva}
                  email={emailNuevo}
                />
              </div>
              <div className="contedor-sucursal">
                <DocumentoSucursalTemplate />
              </div>
            </div>
          </div>
          <Botonera
            tituloboton={botonera}
            verificarFunction={volveraCoopeuchNoSocios}
            volverHome={volveraCoopeuch}
            estadoBotonUno
            estadoBotonDos={false}
            nombreDinamicoResponsive={false}
            activeMenu={menuPosition}
          />
        </FuturaTarjetaWrapper>}
    </>
  );
}

export default GoldCardFinalizada;